import Page from './page'

export default Page


// WEBPACK FOOTER //
// ./src/components/base/page/index.js